import React from 'react';
import { Navigate } from 'react-router';
import { useFlowium } from '../client/FlowiumContext';
import LoadingPage from '../components/LoadingPage';

const PrivateRoute = ({ children }: { children: JSX.Element }) => {
    const { isAuthenticated, isInitializing } = useFlowium();

    if (isInitializing) {
        return <LoadingPage />;
    }

    return isAuthenticated ? children : <Navigate to="/login" />;
};

export default PrivateRoute;
